﻿import $ from "jquery";
import LogoWidget from "./LogoWidget";

export default class LogoWidgetStandalone extends LogoWidget {
	
	constructor() {
		super(...arguments);
	}

	init() {
		super.init();

		const _ = this;

		_.$wrap.attr("data-layout", "standalone");

		const $options = $.map(_.model.products, (data, index) => $("<option>").val(index).text(data.name));

		if (_.model.dropdownIntro) {
			$options.unshift($("<option disabled hidden>").text(_.model.dropdownIntro));
		}
		
		$("<select class='ccs-logo-widget-select'>")
			.append($options)
			.insertAfter(_.$container)
			.on("change", (e) => _.changeProduct(e.target.value));

		_.changeProduct(0, true);
	}
	
	changeProduct(index, suppressLog) {
		const _ = this;

		_.$container.html(_.buildProduct(index));
		_.resize(true);

		if (suppressLog) {
			return;
		}

		const product = _.model.products[index];
		_.logNavigate(product.logData);
	}
}
